import { createReducer } from 'reduxsauce';
import { cloneDeep, isEqual, findIndex, filter } from 'lodash';

import { ShiftDetailsTypes } from '../actions/shift-details.actions';
import { TIME_CLOCK_TYPES, COMMISSION_TYPES } from '../../constants/app.constants';

const initialState = {
  status: [],
  shiftSummary: null,
  shiftBreaks: [],
  shiftActivityTrackers: [],
  shiftMotionTrackers: [],
  shiftCommissions: [],
};

const getShiftDetailsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-shift-details');

  return { ...state, status };
};
const getShiftDetailsSuccess = (state, action) => {
  const shiftDetails = action.response;

  const shiftSummary = {
    id: shiftDetails.id,
    name: shiftDetails.name,
    branchId: shiftDetails.branchId,
    days: shiftDetails.days,
    startTime: shiftDetails.startTime,
    endTime: shiftDetails.endTime,
    startTimeV2: shiftDetails.startTimeV2,
    endTimeV2: shiftDetails.endTimeV2,
    peopleWhenFullyStaffed: shiftDetails.peopleWhenFullyStaffed,
    userGroups: shiftDetails.userGroups,
  };

  const shiftBreaks = filter(shiftDetails.timeClocks, (timeClock) => timeClock.type === TIME_CLOCK_TYPES.break);

  const shiftActivityTrackers = filter(
    shiftDetails.timeClocks,
    (timeClock) => timeClock.type === TIME_CLOCK_TYPES.activity_tracker,
  );

  const shiftMotionTrackers = filter(
    shiftDetails.timeClocks,
    (timeClock) => timeClock.type === TIME_CLOCK_TYPES.motion_tracker,
  );

  const shiftCommissions = shiftDetails.commissions;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-shift-details', a));

  return {
    ...state,
    shiftSummary,
    shiftBreaks,
    shiftActivityTrackers,
    shiftMotionTrackers,
    shiftCommissions,
    status,
  };
};
const getShiftDetailsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-shift-details', a));

  return { ...state, status };
};

const createTimeClockRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-create-timeclock');

  return { ...state, status };
};
const createTimeClockSuccess = (state, action) => {
  const timeClock = action.response;

  const shiftBreaks = cloneDeep(state.shiftBreaks);
  const shiftActivityTrackers = cloneDeep(state.shiftActivityTrackers);
  const shiftMotionTrackers = cloneDeep(state.shiftMotionTrackers);
  if (timeClock.type === TIME_CLOCK_TYPES.break) {
    shiftBreaks.push(timeClock);
  } else if (timeClock.type === TIME_CLOCK_TYPES.activity_tracker) {
    shiftActivityTrackers.push(timeClock);
  } else {
    shiftMotionTrackers.push(timeClock);
  }

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-create-timeclock', a));

  return {
    ...state,
    shiftBreaks,
    shiftActivityTrackers,
    shiftMotionTrackers,
    status,
  };
};
const createTimeClockFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-create-timeclock', a));

  return { ...state, status };
};

const updateTimeClockRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-update-timeclock-${action.timeClockId}`);

  return { ...state, status };
};
const updateTimeClockSuccess = (state, action) => {
  const timeClock = action.response;

  const shiftBreaks = cloneDeep(state.shiftBreaks);
  const shiftActivityTrackers = cloneDeep(state.shiftActivityTrackers);
  const shiftMotionTrackers = cloneDeep(state.shiftMotionTrackers);
  if (timeClock.type === TIME_CLOCK_TYPES.break) {
    const idx = findIndex(shiftBreaks, (e) => e.id === timeClock.id);
    if (idx > -1) shiftBreaks[idx] = timeClock;
  } else if (timeClock.type === TIME_CLOCK_TYPES.activity_tracker) {
    const idx = findIndex(shiftActivityTrackers, (e) => e.id === timeClock.id);
    if (idx > -1) shiftActivityTrackers[idx] = timeClock;
  } else {
    const idx = findIndex(shiftMotionTrackers, (e) => e.id === timeClock.id);
    if (idx > -1) shiftMotionTrackers[idx] = timeClock;
  }

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-update-timeclock-${timeClock.id}`, a));

  return {
    ...state,
    shiftBreaks,
    shiftActivityTrackers,
    shiftMotionTrackers,
    status,
  };
};
const updateTimeClockFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-update-timeclock-${action.timeClockId}`, a));

  return { ...state, status };
};

const deleteTimeClockRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-delete-timeclock-${action.timeClockId}`);

  return { ...state, status };
};
const deleteTimeClockSuccess = (state, action) => {
  const { timeClockId, timeClockType } = action;

  let shiftBreaks = cloneDeep(state.shiftBreaks);
  let shiftActivityTrackers = cloneDeep(state.shiftActivityTrackers);
  let shiftMotionTrackers = cloneDeep(state.shiftMotionTrackers);
  if (timeClockType === TIME_CLOCK_TYPES.break) {
    shiftBreaks = filter(shiftBreaks, (e) => !isEqual(e.id, timeClockId));
  } else if (timeClockType === TIME_CLOCK_TYPES.activity_tracker) {
    shiftActivityTrackers = filter(shiftActivityTrackers, (e) => !isEqual(e.id, timeClockId));
  } else {
    shiftMotionTrackers = filter(shiftMotionTrackers, (e) => !isEqual(e.id, timeClockId));
  }

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-delete-timeclock-${timeClockId}`, a));

  return {
    ...state,
    shiftBreaks,
    shiftActivityTrackers,
    shiftMotionTrackers,
    status,
  };
};
const deleteTimeClockFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-delete-timeclock-${action.timeClockId}`, a));

  return { ...state, status };
};

const createIndividualCommissionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-crete-individual-commissions');

  return { ...state, status };
};
const createIndividualCommissionsSuccess = (state, action) => {
  const shiftCommissions = cloneDeep(state.shiftCommissions);
  shiftCommissions[COMMISSION_TYPES.individual] = action.response;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-crete-individual-commissions', a));

  return { ...state, shiftCommissions, status };
};
const createIndividualCommissionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-crete-individual-commissions', a));

  return { ...state, status };
};

const updateIndividualCommissionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-update-individual-commissions');

  return { ...state, status };
};
const updateIndividualCommissionsSuccess = (state, action) => {
  const shiftCommissions = cloneDeep(state.shiftCommissions);
  shiftCommissions[COMMISSION_TYPES.individual] = action.response;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-update-individual-commissions', a));

  return { ...state, shiftCommissions, status };
};
const updateIndividualCommissionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-update-individual-commissions', a));

  return { ...state, status };
};

const deleteIndividualCommissionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-delete-individual-commissions');

  return { ...state, status };
};
const deleteIndividualCommissionsSuccess = (state) => {
  const shiftCommissions = cloneDeep(state.shiftCommissions);
  shiftCommissions[COMMISSION_TYPES.individual] = [];

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-delete-individual-commissions', a));

  return { ...state, shiftCommissions, status };
};
const deleteIndividualCommissionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-delete-individual-commissions', a));

  return { ...state, status };
};

const createTeamCommissionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-crete-team-commissions');

  return { ...state, status };
};
const createTeamCommissionsSuccess = (state, action) => {
  const shiftCommissions = cloneDeep(state.shiftCommissions);
  shiftCommissions[COMMISSION_TYPES.team] = action.response;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-crete-team-commissions', a));

  return { ...state, shiftCommissions, status };
};
const createTeamCommissionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-crete-team-commissions', a));

  return { ...state, status };
};

const updateTeamCommissionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-update-team-commissions');

  return { ...state, status };
};
const updateTeamCommissionsSuccess = (state, action) => {
  const shiftCommissions = cloneDeep(state.shiftCommissions);
  shiftCommissions[COMMISSION_TYPES.team] = action.response;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-update-team-commissions', a));

  return { ...state, shiftCommissions, status };
};
const updateTeamCommissionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-update-team-commissions', a));

  return { ...state, status };
};

const deleteTeamCommissionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-delete-team-commissions');

  return { ...state, status };
};
const deleteTeamCommissionsSuccess = (state) => {
  const shiftCommissions = cloneDeep(state.shiftCommissions);
  shiftCommissions[COMMISSION_TYPES.team] = [];

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-delete-team-commissions', a));

  return { ...state, shiftCommissions, status };
};
const deleteTeamCommissionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-delete-team-commissions', a));

  return { ...state, status };
};

const createPerVehicleCommissionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-crete-pervehicle-commissions');

  return { ...state, status };
};
const createPerVehicleCommissionsSuccess = (state, action) => {
  const shiftCommissions = cloneDeep(state.shiftCommissions);
  shiftCommissions[COMMISSION_TYPES.per_vehicle] = action.response;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-crete-pervehicle-commissions', a));

  return { ...state, shiftCommissions, status };
};
const createPerVehicleCommissionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-crete-pervehicle-commissions', a));

  return { ...state, status };
};

const updatePerVehicleCommissionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-update-pervehicle-commissions');

  return { ...state, status };
};
const updatePerVehicleCommissionsSuccess = (state, action) => {
  const shiftCommissions = cloneDeep(state.shiftCommissions);
  shiftCommissions[COMMISSION_TYPES.per_vehicle] = action.response;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-update-pervehicle-commissions', a));

  return { ...state, shiftCommissions, status };
};
const updatePerVehicleCommissionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-update-pervehicle-commissions', a));

  return { ...state, status };
};

const deletePerVehicleCommissionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-delete-pervehicle-commissions');

  return { ...state, status };
};
const deletePerVehicleCommissionsSuccess = (state) => {
  const shiftCommissions = cloneDeep(state.shiftCommissions);
  shiftCommissions[COMMISSION_TYPES.per_vehicle] = [];

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-delete-pervehicle-commissions', a));

  return { ...state, shiftCommissions, status };
};
const deletePerVehicleCommissionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-delete-pervehicle-commissions', a));

  return { ...state, status };
};

const clearShiftDetailsRequest = (state) => ({ ...state, ...initialState });

export const reducer = createReducer(initialState, {
  [ShiftDetailsTypes.GET_SHIFT_DETAILS_REQUEST]: getShiftDetailsRequest,
  [ShiftDetailsTypes.GET_SHIFT_DETAILS_SUCCESS]: getShiftDetailsSuccess,
  [ShiftDetailsTypes.GET_SHIFT_DETAILS_FAILURE]: getShiftDetailsFailure,

  [ShiftDetailsTypes.CREATE_TIME_CLOCK_REQUEST]: createTimeClockRequest,
  [ShiftDetailsTypes.CREATE_TIME_CLOCK_SUCCESS]: createTimeClockSuccess,
  [ShiftDetailsTypes.CREATE_TIME_CLOCK_FAILURE]: createTimeClockFailure,

  [ShiftDetailsTypes.UPDATE_TIME_CLOCK_REQUEST]: updateTimeClockRequest,
  [ShiftDetailsTypes.UPDATE_TIME_CLOCK_SUCCESS]: updateTimeClockSuccess,
  [ShiftDetailsTypes.UPDATE_TIME_CLOCK_FAILURE]: updateTimeClockFailure,

  [ShiftDetailsTypes.DELETE_TIME_CLOCK_REQUEST]: deleteTimeClockRequest,
  [ShiftDetailsTypes.DELETE_TIME_CLOCK_SUCCESS]: deleteTimeClockSuccess,
  [ShiftDetailsTypes.DELETE_TIME_CLOCK_FAILURE]: deleteTimeClockFailure,

  [ShiftDetailsTypes.CREATE_INDIVIDUAL_COMMISSIONS_REQUEST]: createIndividualCommissionsRequest,
  [ShiftDetailsTypes.CREATE_INDIVIDUAL_COMMISSIONS_SUCCESS]: createIndividualCommissionsSuccess,
  [ShiftDetailsTypes.CREATE_INDIVIDUAL_COMMISSIONS_FAILURE]: createIndividualCommissionsFailure,

  [ShiftDetailsTypes.UPDATE_INDIVIDUAL_COMMISSIONS_REQUEST]: updateIndividualCommissionsRequest,
  [ShiftDetailsTypes.UPDATE_INDIVIDUAL_COMMISSIONS_SUCCESS]: updateIndividualCommissionsSuccess,
  [ShiftDetailsTypes.UPDATE_INDIVIDUAL_COMMISSIONS_FAILURE]: updateIndividualCommissionsFailure,

  [ShiftDetailsTypes.DELETE_INDIVIDUAL_COMMISSIONS_REQUEST]: deleteIndividualCommissionsRequest,
  [ShiftDetailsTypes.DELETE_INDIVIDUAL_COMMISSIONS_SUCCESS]: deleteIndividualCommissionsSuccess,
  [ShiftDetailsTypes.DELETE_INDIVIDUAL_COMMISSIONS_FAILURE]: deleteIndividualCommissionsFailure,

  [ShiftDetailsTypes.CREATE_TEAM_COMMISSIONS_REQUEST]: createTeamCommissionsRequest,
  [ShiftDetailsTypes.CREATE_TEAM_COMMISSIONS_SUCCESS]: createTeamCommissionsSuccess,
  [ShiftDetailsTypes.CREATE_TEAM_COMMISSIONS_FAILURE]: createTeamCommissionsFailure,

  [ShiftDetailsTypes.UPDATE_TEAM_COMMISSIONS_REQUEST]: updateTeamCommissionsRequest,
  [ShiftDetailsTypes.UPDATE_TEAM_COMMISSIONS_SUCCESS]: updateTeamCommissionsSuccess,
  [ShiftDetailsTypes.UPDATE_TEAM_COMMISSIONS_FAILURE]: updateTeamCommissionsFailure,

  [ShiftDetailsTypes.DELETE_TEAM_COMMISSIONS_REQUEST]: deleteTeamCommissionsRequest,
  [ShiftDetailsTypes.DELETE_TEAM_COMMISSIONS_SUCCESS]: deleteTeamCommissionsSuccess,
  [ShiftDetailsTypes.DELETE_TEAM_COMMISSIONS_FAILURE]: deleteTeamCommissionsFailure,

  [ShiftDetailsTypes.CREATE_PER_VEHICLE_COMMISSIONS_REQUEST]: createPerVehicleCommissionsRequest,
  [ShiftDetailsTypes.CREATE_PER_VEHICLE_COMMISSIONS_SUCCESS]: createPerVehicleCommissionsSuccess,
  [ShiftDetailsTypes.CREATE_PER_VEHICLE_COMMISSIONS_FAILURE]: createPerVehicleCommissionsFailure,

  [ShiftDetailsTypes.UPDATE_PER_VEHICLE_COMMISSIONS_REQUEST]: updatePerVehicleCommissionsRequest,
  [ShiftDetailsTypes.UPDATE_PER_VEHICLE_COMMISSIONS_SUCCESS]: updatePerVehicleCommissionsSuccess,
  [ShiftDetailsTypes.UPDATE_PER_VEHICLE_COMMISSIONS_FAILURE]: updatePerVehicleCommissionsFailure,

  [ShiftDetailsTypes.DELETE_PER_VEHICLE_COMMISSIONS_REQUEST]: deletePerVehicleCommissionsRequest,
  [ShiftDetailsTypes.DELETE_PER_VEHICLE_COMMISSIONS_SUCCESS]: deletePerVehicleCommissionsSuccess,
  [ShiftDetailsTypes.DELETE_PER_VEHICLE_COMMISSIONS_FAILURE]: deletePerVehicleCommissionsFailure,

  [ShiftDetailsTypes.CLEAR_SHIFT_DETAILS_REQUEST]: clearShiftDetailsRequest,
});
